import i18next from 'i18next';

import { CLAIM, PROCEDURE } from '../../../constants/userForms';

i18next.addResources('es', 'EdelapCommons', {
  accept: 'Aceptar',
  cancel: 'Cancelar',
  close: 'Cerrar',
  back: 'Volver',
  email: 'Email',
  type: 'Tipo',
  consult: 'Consultar',
  status: 'Estado',
  address: 'Dirección',
  return: 'Volver',
  modify: 'Modificar',
  confirm: 'Confirmar',
  clientNumber: 'NIS',
  selectAll: 'Seleccionar todo',
  of: 'de',
  office: 'Sede',
  reload: 'Recargar',
  reference: 'Referencias',
  enabled: 'Disponible',
  disabled: 'No disponible',
  selected: 'Seleccionado',
  procedure: 'Trámite',
  send: 'Enviar'
});

i18next.addResources('es', 'EdelapServiceAdherence', {
  digitalBillAdherence: 'Adhesión a factura digital'
});

i18next.addResources('es', 'EdelapDefaultMessages', {
  // Account actions
  addAccountSuccess: 'El suministro fue registrado exitosamente.',
  addAccountFailure: 'No se pudo registrar tu suministro en este momento. Por favor intentá más tarde.',
  addAccountsSuccess: 'El suministro fue registrado exitosamente.',
  addAccountsFailure: 'No se pudo registrar tu suministro en este momento. Por favor intentá más tarde.',
  getAccountAsyncFailure: 'Hubo un error al recuperar tu estado de cuenta.',
  deleteAccountSuccess: 'El suministro fue desvinculado exitosamente.',
  deleteAccountFailure: 'El suministro no pudo desvincularse en este momento, por favor intentá más tarde.',
  getQuestionsFailure: 'Hubo un problema al solicitar la información.',
  getRelatedAccountsFailure: 'Hubo un error al recuperar los suministros relacionados',
  getTermsAndConditionsFailure:
    'Hubo un error al recuperar los términos y condiciones, por favor intente nuevamente mas tarde.',
  validateSocialRateFailure:
    'Hubo un problema al procesar tu consulta, por favor intentá nuevamente más tarde.',
  getAccountBalanceFailure:
    'Hubo un error al recuperar el saldo de tu suministro, por favor reintentá más tarde.',
  getTermsOfServiceFailure:
    'Hubo un error al recuperar los terminos y condiciones, por favor intentá nuevamente más tarde.',
  acceptServiceAgreementSuccess: 'La adhesión al servicio se ha realizado exitosamente.',
  acceptServiceAgreementFailure:
    'Hubo un error al procesar tu solicitud, por favor intentá nuevamente más tarde.',
  evaluateChangeExpirationDateFailure:
    'Hubo un error al recuperar la información de tus fechas de vencimiento actuales, por favor intentá nuevamente más tarde',
  changeExpirationDateFailure:
    'Hubo un error al actualizar tu fecha de vencimiento. Por favor intentá nuevamente más tarde',
  changeExpirationDateSuccess: 'La fecha de vencimiento fue actualizada exitosamente',
  positiveCreditStatusFailure:
    'Hubo un error al procesar tu solicitud, por favor intentá nuevamente más tarde.',
  getAccountsInfoFailure: 'Hubo un error al recuperar sus cuentas.',

  // Auth actions
  signInFailure: 'No se pudo iniciar sesión, el servicio no está disponible en este momento.',
  signUpFailure: 'No se pudo crear el usuario, el servicio no está disponible en este momento.',
  changePrimaryEmailFailure: 'Hubo un error al enviarle el código para validar el email',
  changePrimaryEmailSuccess: 'Se ha enviado un código a su email para validarlo',
  validateChangeEmailFailure: 'Hubo un error al validar el código enviado a su email',
  validateChangeEmailSuccess: 'Su email ha sido modificado correctamente',
  validateEmailFailure: 'Hubo un error al validar tu email. Por favor intentá nuevamente más tarde',
  resendVerificationCodeSuccess: 'El código fue reenviado a tu email.',
  resendVerificationCodeFailure: 'No se pudo iniciar sesión, el servicio no está disponible en este momento.',
  newPasswordRequestSuccess: 'En instantes recibirás un Email para cambiar tu contraseña.',
  newPasswordRequestFailure:
    'No se pudo recuperar la contraseña, el servicio no está disponible en este momento',
  changePasswordSuccess: 'Se ha cambiado la contraseña correctamente.',
  changePasswordFailure: 'No se ha podido cambiar la contraseña,por favor intente nuevamente más tarde.',
  samePasswords: 'La nueva contraseña no puede ser igual a la actual.',
  authInvalidNewPasswords: 'Las contraseñas ingresadas deben coincidir.',
  tokenError: 'Ya se ha usado este link, por favor solicite uno nuevo',
  recoveryPasswordSuccess: 'Se ha cambiado la contraseña correctamente.',
  recoveryPasswordFailure: 'No se ha podido cambiar la contraseña. Revise su conexión de internet.',
  getIdentityValidationFormFailure: 'No se pudo procesar tu pedido. Probá intentando de nuevo más tarde.',
  validateIdentityAnswersFailure: 'No se pudo procesar tu pedido. Probá intentando de nuevo más tarde.',
  getUserInformationFailure: 'No se pudo procesar tu pedido. Probá intentando de nuevo más tarde.',
  getUserProfileFailure: 'No se pudo procesar tu pedido. Probá intentando de nuevo más tarde.',
  updateUserProfileFailure:
    'Hubo un error al actualizar su información, por favor intente nuevamente más tarde.',
  updateUserProfileSuccess: 'La información fue actualizada exitosamente.',
  getUserIdentificationFailure:
    'Hubo un problema al verificar tus datos, por favor intenta nuevamente más tarde.',

  // Bill actions
  getBillsFailure: 'Hubo un error al recuperar tus facturas. Intentá más tarde.',
  getCurrentBillFailure: 'Hubo un error al recuperar tus facturas. Intentá más tarde.',
  getPrintedBillFailure: 'Hubo un error al descargar tu factura.',
  getBillProgressFailure: 'Hubo un error al recuperar tus facturas. Intentá más tarde.',
  getConsumptionHistoryFailure: 'Hubo un error al recuperar tus facturas. Intentá más tarde.',
  appendBillsFailure: 'Hubo un error al recuperar tus facturas. Intentá más tarde.',
  getPublicPaymentDocumentFailure: 'El suministro no registra liquidaciones emitidas pendientes de pago.',
  getLastBillInformationFailure:
    'Hubo un error al recuperar la información de tu última factura, por favor reintenta más tarde',
  getMultipleBillsFailure: 'Hubo un error al recuperar tus facturas. Intentá más tarde.',

  // Custom Procedures actions
  evaluateAccountHolderChangeFailure: 'Hubo un error intente nuevamente mas tarde.',
  getAccountDataFailure: 'Hubo un error intente nuevamente mas tarde.',
  createHolderChangeFailure: 'Hubo un error intente nuevamente mas tarde.',
  getAccountProceduresFailure: 'Hubo un error intente nuevamente mas tarde.',
  evaluateTerminationRequestFailure: 'Hubo un error intente nuevamente mas tarde.',
  cancelCustomProcedureSuccess: 'Se ha cancelado el trámite correctamente',
  cancelCustomProcedureFailure: 'Hubo un error intente nuevamente mas tarde.',
  entitiesLoginFailure: 'Hubo un error al iniciar sesión',

  // Notification actions
  getUserNotificationsFailure: 'Hubo un error en la busqueda de tus notificaciones.',
  appendNotificationsFailure: 'Hubo un error intente nuevamente mas tarde.',
  setNotificationsSeenFailure: 'Hubo un error intente nuevamente mas tarde.',
  setNotificationAsReadFailure: 'Hubo un error intente nuevamente mas tarde.',

  // Payment actions
  getPaymentDocumentFailure: 'Hubo un error al recuperar tu deuda, por favor intentá nuevamente más tarde.',
  getLastBillFailure: 'Hubo un error al recuperar tu factura. Intentá más tarde.',
  getAccountUnpaidFailure: 'Hubo un error al recuperar tu deuda, por favor intentá nuevamente más tarde.',
  getUserUnpaidBillsFailure: 'Hubo un error al recuperar tu deuda, por favor intentá nuevamente más tarde.',
  getPayableDocumentsFailure: 'Hubo un error al recuperar tu deuda, por favor intentá nuevamente más tarde.',
  getPaymentTokenFailure: 'Hubo un error al procesar tu pago, por favor intentá nuevamente más tarde.',
  paymentRequestFailure: 'Hubo un error al procesar tu pago, por favor intentá nuevamente más tarde.',
  getPaymentIdentifierFailure: 'Hubo un error al procesar tu pago, por favor intentá nuevamente más tarde.',

  // Point actions
  getPointsDetailFailure: 'Tus puntos no pudieron ser recuperados, por favor intenta más tarde.',
  appendPointsTransactionsFailure: 'Tus puntos no pudieron ser recuperados, por favor intenta más tarde.',

  // Tip actions
  getEnergyTipsFailure: 'Hubo un error al conseguir los consejos. Intentá más tarde.',
  tipToggleLike: 'Hubo un error al querer ponerle like. Intentá más tarde.',

  // User Form actions
  getFormResponsesFailure: 'Hubo un error intente nuevamente mas tarde.',
  appendFormResponsesFailure: 'Hubo un error intente nuevamente mas tarde.',
  getFormCategoriesFailure: 'Hubo un error intente nuevamente mas tarde.',
  getPublicFormCategoriesFailure: 'Hubo un error intente nuevamente mas tarde.',
  getFormFailure: 'Hubo un error intente nuevamente mas tarde.',
  getFormResponseDetailsFailure: 'Hubo un error intente mas tarde.',
  submitFormFailure: 'No se pudo procesar tu pedido. Probá intentando de nuevo más tarde.',
  claimSubmitSuccess: 'El reclamo se creó correctamente.',
  procedureSubmitSuccess: 'El trámite se creó correctamente.',
  procedureSurveySubmitSuccess: '¡Muchas gracias!',
  paymentSurveySubmitSuccess: '¡Muchas gracias!',
  submitPublicFormFailure: 'No se pudo procesar tu pedido. Probá intentando de nuevo más tarde.',
  reiterationFailure: 'No se pudo reiterar el trámite.',
  reiterationSuccess: 'El trámite fue reiterado satisfactoriamente.',
  cancelationFailure: 'No se pudo cancelar el trámite.',
  cancelationSuccess: 'El trámite fue cancelado satisfactoriamente.',

  // Vouchers actions
  getVouchersInfoFailure: 'Hubo un error al recuperar los vouchers',
  voucherExchangeFailure: 'No es posible efectuar el canje.',

  // Forms
  uploadFileError: 'Se produjo un error al subir tu archivo.',

  // Turns
  getFormsFailure: 'Hubo un error al recuperar los trámites.',
  getOfficesFailure: 'Hubo un error al recuperar las oficinas disponibles.',
  getUserTurnsFailure: 'Hubo un error al recuperar los turnos. Probá intentando de nuevo más tarde.',
  getOfficeDaysFailure: 'Hubo un error al recuperar los días disponibles.',
  getOfficeSlotFailure: 'Hubo un error al recuperar los horarios de la oficina.',
  createNewTurnSuccess: 'Su turno fue creado con exito.',
  createNewTurnFailure: 'Hubo un error al crear el turno. Probá intentando de nuevo más tarde.',
  cancelationTurnSuccess: 'Su tramite fue cancelado con exito.',
  cancelationTurnFailure: 'Hubo un error al cancelar el turno. Probá intentando de nuevo más tarde.',
  updateTurnSuccess: 'Su turno fue actualizado con exito.',
  updateTurnFailure: 'Hubo un error al actualizar su turno. Probá intentando de nuevo más tarde.'
});

i18next.addResources('es', 'EdelapErrorScreen', {
  error: '¡Ups!',
  noElements: '¡Nada por aquí!',
  timer: 'Un segundo, por favor',
  noItemsError: 'No se encontraron resultados',
  userWithoutAccounts: `Ud. no posee suministros asociados a su nombre.\n <br> En caso de querer solicitar la conexión de un servicio dado de baja, podrá gestionar el ALTA DE SERVICIO, ingresando el Número de Suministro  (NIS: 9 dígitos) correspondiente al inmueble, en el menú de Atención al Usuario/Alta de suministro.\n <br>Si el inmueble ya cuenta con suministro, y usted requiere realizar un CAMBIO DE TITULARIDAD podrá gestionarlo ingresando el Número de Suministro  (NIS: 9 dígitos) correspondiente al inmueble, en el menú de Atención al Usuario/cambio de titularidad.\n <br>* Le recordamos que esta opción solo se encuentra disponible para suministros Residenciales.
    `
});

i18next.addResources('es', 'EdelapTurns', {
  myTurns: 'Mis turnos',
  requestTurn: 'Solicitar turno',
  requestTurnTitle: 'Buscá y solicitá tu turno en línea',
  requestTurnSubtitle: 'Solicitá un nuevo turno para realizar tus gestiones desde ahí',
  nextTurns: 'Próximos turnos',
  withoutTurnsTitle: 'No tenés turnos próximos',
  withoutTurnsSubtitle: 'Buscá y solicitá un turno en línea.',
  newTurnTitle: 'Solicitá tu turno online',
  selectOffice: 'Seleccioná la oficina',
  selectDate: 'Seleccioná la fecha',
  selectTime: 'Seleccioná el horario',
  titleErrorCard: 'Ups! Hubo un problema',
  buttonErrorCard: 'Recargar Formulario',
  confirmatedTurn: 'Confirmá tu turno',
  confirmatedTurnTitle: ' Detalles del turno seleccionado',
  confirmatedTurnSubtitle: ' presiona la opcion que deseas modificar',
  cancelationTurnTitle: 'Cancelación de turno',
  cancelationTurnContent: '¿Seguro que queres cancelar el turno?',
  officesIsEmpty: 'No se encontraron oficinas para generar tu turno.',
  selectFormTitle: 'Seleccioná el trámite a realizar',
  selectFormPlaceHolder: 'Seleccionar tramite',
  selectFormAlertInfo:
    'Te recordamos que el trámite que seleccionaste podes realizarlo de manera online a través de tu oficina virtual,<br/> ingresa y selecciona la opción “Atención al usuario”',
  confirmatedTurnModal: 'Turno confirmado',
  presentationRequirementsTitle: 'Debés presentarte con la siguiente información:',
  presentationRequirements: '[Requisitos de presentación]({{presentationRequirementsURL}})',
  modalFormAlertInfo:
    'Te recordamos que el trámite que seleccionaste podes realizarlo de manera online a través de tu oficina virtual, ingresa y selecciona la opción “Atención al usuario”',
  calendarInfo: 'El calendario habilitará sólo los días con turnos disponibles.',
  withoutSlots: 'No hay turnos disponibles',
  contactInformation: 'Datos de contacto',
  updateUserInformation:
    'Los datos ingresados actualmente no los tenés en tu perfil de usuario, te sugerimos actualizarlos para próximas comunicaciones',
  calendarWarning: 'Recordá que no se puede pedir turno para el mismo día.'
});

i18next.addResources('es', 'EdelapUTFileInput', {
  selectFile: 'Seleccionar archivo'
});

i18next.addResources('es', 'EdelapMaps', {
  locationDisabled:
    'La ubicación se encuentra desactivada, por favor habilitarla desde la configuración de su navegador',
  locationError: 'No pudimos determinar tu ubicación',
  locationSearching: 'Estamos recuperando tu ubicación...',
  searchPlaceholder: 'Ingrese una dirección',
  invalidConfig:
    'No se encuentran configuradas en el field las keys a utilizar para alguno de los siguientes campos: latitude, longitude y/o formatted_address'
});

i18next.addResources('es', 'EdelapPhoneInput', {
  areaCodeLabel: 'Cod. área',
  areaCodePlaceholder: 'Sin 0',
  phoneNumber: 'Número de teléfono',
  codeWithZero: 'Ingrese el código sin 0',
  invalidCode: 'Código de área invalido',
  phoneWithZero: 'El número no debe tener 0',
  phoneWithFifteen: 'El número no debe tener 15'
});

i18next.addResources('es', 'EdelapFormCreator', {
  claimInit: 'Servicio Técnico',
  claimCategories: 'Tipo de reclamo',
  procedureInit: 'Nuevo trámite',
  procedureSurveyInit: 'Completa la encuesta',
  paymentSurveyInit: 'Encuesta de pago  ',
  procedureCategories: 'Tipo de trámite',
  procedureInitError: 'Hubo un error al iniciar el trámite.',
  claimInitError: 'Hubo un error al iniciar el reclamo.',
  complaintInitError: 'Hubo un error al iniciar la denuncia.',
  submitSuccess: 'Su pedido se registró satisfatoriamente',
  loading: 'Cargando',
  goToProcedure: 'Ir al trámite',
  defaultAlertModalTitle: 'Información',
  uploadFileError: 'Se produjo un error al subir tu archivo.'
});

i18next.addResources('es', 'EdelapConfiguration', {
  basicInformation: 'Información básica',
  user: 'Usuario',
  changePassword: 'Cambiar Contraseña',
  userInformation: 'Datos de contacto',
  passwordChangeError: 'No se ha podido cambiar la contraseña, por favor intente nuevamente más tarde',
  invalidCurrentPassword: 'La contraseña actual es incorrecta.',
  notifications: 'Notificaciones',
  authSubmitError: 'No se pudo procesar su pedido. Pruebe intentando de nuevo más tarde.',
  configurationSummary: 'Configuración del usuario',
  configuration: 'Configuración',
  change: 'Cambiar',
  close: 'Cerrar',
  configurationLabel: `Las contraseñas son sensibles a las mayúsculas y deben contener como mínimo 8 caracteres.`,
  notificationsSettingDescription: `Elige si querés recibir notificaciones sobre vencimientos, disponibilidad de facturas o problemas en tu zona.`,
  typeCurrentPassword: 'Contraseña actual',
  typeNewPassword: 'Contraseña nueva',
  confirmNewPassword: 'Volvé a escribir tu contraseña nueva',
  phone: 'Nro de teléfono',
  phoneWithoutZero: 'Nro de teléfono (sin 0 y sin 15)',
  mobile: 'Celular',
  email: 'Email',
  save: 'Guardar',
  samePasswords: 'La nueva contraseña no puede ser igual a la actual.',
  yes: 'Si',
  no: 'No',
  primaryPhone: 'Primario',
  phonesTitle: 'Teléfonos',
  emailsTitle: 'Direcciones de email',
  passwordPlaceholder: 'Ingrese su contraseña',
  saveButton: 'Guardar cambios',
  userInfoSubmitError: 'Por favor, verificá los datos ingresados',
  emailIsRequired: 'Al menos un email es requerido',
  phoneIsRequired: 'Al menos un télefono es requerido',
  defaultPhoneRequired: 'Por favor seleccione un télefono como medio de contacto prioritario',
  carrier: 'Compañia',
  changeEmailModalContent: 'El email ingresado será tomado como su nuevo email primario.',
  changePrimaryEmailTitle: 'Cambio de email',
  changeEmailPlaceholder: 'Ingrese su email',
  validateCodePlaceholder: 'Ingrese el código de 4 digitos.'
});

i18next.addResources('es', 'EdelapChangeUserInfo', {
  title: 'Datos de contacto',
  warningMessage:
    'Antes de comenzar a administrar su servicio, por favor confirme sus datos de contacto de manera de tener una comunicación más eficiente, muchas gracias.',
  withoutData: 'Sin datos'
});

i18next.addResources('es', 'EdelapFieldDetails', {
  reiterate: 'Reiterar',
  pending: 'En curso',
  cancelled: 'Cancelado',
  cancelled2: 'Cancelada',
  rejected: 'Rechazado',
  completed: 'Completado',
  completionAt: 'Fecha de completitud',
  expectedCompletionAt: 'Fecha estimada de completitud',
  [PROCEDURE]: 'Trámites',
  [CLAIM]: 'Reclamos',
  cancelPlaceholder: 'Ingrese el motivo de su cancelación..',
  reiteratePlaceholder: 'Ingrese un comentario.. ',
  fieldRequired: 'Este campo es obligatorio'
});

i18next.addResources('es', 'EdelapSidebar', {
  invoicesAndPayments: 'Facturas y pagos',
  technicalService: 'Servicio técnico',
  accountStatus: 'Suministro',
  customerSupport: 'Atención al usuario',
  energyAdvisor: 'Asesor energético',
  newClaim: 'Generar reclamo',
  claims: 'Consulta de estado de reclamos',
  newProcedure: 'Generar trámite comercial',
  procedures: 'Consulta de estado de trámites',
  complaints: 'Denuncias',
  altSidebarButton: 'Botón de Sidebar',
  altArrowButton: 'Botón desplegable',
  chatbox: 'Agente virtual',
  invoicesList: 'Lista de facturas',
  documentsAndPayments: 'Cupones y pagos',
  paymentDocuments: 'Cupones de pago',
  payments: 'Pagá tu factura',
  points: 'Tus puntos',
  settings: 'Configuración',
  socialRate: 'Consulta de tarifa social',
  lastBillQuery: 'Importe y vencimiento',
  balanceQuery: 'Consulta de saldo',
  accountHolderChange: 'Cambio de titularidad',
  terminationRequest: 'Dar de baja un servicio',
  changeDueDate: 'Cambio de fecha de vencimiento para Jubilados/Pensionados',
  registerAccount: 'Dar de alta un servicio',
  simulatorButton: 'Simulador de consumo',
  consultDepositWarranty: 'Consulta depósito en garantía',
  consultFineQuality: 'Consulta bonificación por calidad de servicio',
  myTurns: 'Mis turnos'
});

i18next.addResources('es', 'EdelapNotification', {
  withoutNotifications: 'No tenés ninguna notificación'
});

i18next.addResources('es', 'EdelapAccountDetails', {
  digitalBill: 'Factura digital',
  automaticDebit: 'Débito automático',
  mainCustomer: 'Usuario principal',
  notMainCustomer: 'No es el usuario principal del suministro',
  detail: 'Detalle',
  subscribed: 'Adherido',
  subscribe: 'Adherirse'
});

i18next.addResources('es', 'EdelapAccounts', {
  relatedSuppliesInformation:
    'Contás con suministros relacionados pendientes de asociar. En caso de querer enlazarlos, podrás hacerlo desde el botón Asociar',
  associate: 'Asociar',
  relatedAccounts: 'Suministros relacionados',
  address: 'Dirección',
  accounts: 'Mis suministros',
  addAccount: 'Añadir suministro',
  clientNumber: 'Número de suministro',
  clientNumberInput: 'Número de suministro',
  clientNumberPlaceholder: '',
  clientN: 'N° de suministro',
  selectAccounts: 'SELECCIONAR CUENTAS',
  holderName: 'Nombre del titular',
  add: 'Añadir',
  next: 'Siguiente',
  createAccountMessage: 'Registrá un suministro ingresando el NIS',
  accountRequired: 'Debe ingresar un número de suministro',
  wrongAnswers: 'Las respuestas seleccionadas son incorrectas.',
  lengthValidation: 'El NIS debe ser de {{count}} caracteres',
  accountRegistered: 'Ya registraste ese número de suministro',
  accountRelationship: 'Relación con suministro',
  mainCustomer: 'Usuario principal',
  secondaryCustomer: 'Usuario secundario',
  deleteAccount: 'Desvincular suministro',
  deleteAccountConfirmation: '¿Está seguro que desea desvincular este suministro?',
  tooltip: ''
});

i18next.addResources('es', 'EdelapAccountStatus', {
  // General
  direction: 'Dirección',
  clientNumber: 'Número de suministro',
  since: 'hasta',

  // Account
  account: 'Suministro',
  myAccounts: 'Mis suministros',
  adheredService: 'Adherido',
  notAdheredService: 'No Adherido',
  adherenceInProgress: 'Adhesión en curso',
  digitalBill: 'Factura digital',
  automaticDebit: 'Débito automático',
  T1: 'Pequeña Demanda',
  T1R: 'Residencial',
  T1S: 'Tarifa Social',
  T1G: 'General',
  T2: 'Mediana Demanda',
  T3: 'Grandes Demandas',
  T5: 'Peaje',
  adhere: 'Adherir',

  // Account Status
  accountStatus: 'Estado de cuenta',
  amountToPay: 'Importe a pagar',
  payNow: 'Pagar ahora',
  paymentDocument: 'Cupón de pago',
  periodDetail: 'Detalles del período {{period}}',
  filterPlaceholder: 'Ingrese NIS o dirección',

  // Last Bill
  lastBill: 'Última factura',
  period: 'Período',
  dateOfIssue: 'Fecha de emisión',
  periodStartedOn: 'Fecha desde {{startDate}}',
  periodEndedOn: 'Fecha hasta',
  consumption: 'Consumo',
  amount: 'Importe',
  downloadBill: 'Descargar',
  surchargeAmount: 'Importe',
  dueDate: 'Fecha de vencimiento',

  // Consumption Comparison
  consumptionComparison: 'Gráfico de consumos',
  yourAnualProgress: 'Tu progreso anual',
  efficientMessage:
    '¡Felicitaciones! Ahorraste un {{saving}}% y eso produjo un impacto positivo en el medio ambiente.',
  noEfficientMessage:
    'Tu consumo aumentó un {{saving}}%. Consultá el asesor energético y obtené valiosos tips para poder mejorar.',
  noConsumptionMessage:
    'No contás con consumo registrado para el año anterior. Consultá el asesor energético y obtené valiosos tips. ¡Empezá a ahorrar hoy!',

  // Graphics
  consumptionOnPeak: 'Punta',
  consumptionOffPeak: 'Fuera de punta',
  consumptionRemainder: 'Resto',
  consumptionValley: 'Valle',
  powerBilledOnPeak: 'Punta',
  powerBilledOffPeak: 'Fuera de punta',
  billedPower: 'Potencia',
  energy: 'Energía',

  // Error Message
  noAccounts: 'Debe tener cuentas asociadas para poder realizar esta accion.',
  noBillsAssociatedError: 'A la fecha no se registran periodos facturados a su nombre',
  claimsRestricted:
    'Esta transacción se encuentra restringida debido a su estado de cuenta, por problemas en la vía pública puede avisar en forma anónima y gratuita a través de nuestro Centro de Atención Telefónica 0800 222 3335, todos los días las 24 horas, o dirigirse personalmente a nuestras oficinas comerciales de lunes a viernes de 8 a 14:30 horas',
  restricted: 'Esta transacción se encuentra restringida debido a tu estado de cuenta actual',

  // Anual progress
  calcExplanationOne:
    'El cálculo de los consumos acumulados se basa en el consumo acumulado hasta el período actual, tanto para el año actual como para el año anterior.',
  calcExplanationTwo: 'En este caso, el consumo acumulado se calcula hasta Mayo de ambos años, resultando:'
});

i18next.addResources('es', 'EdelapBill', {
  issued_on: 'Emisión',
  consumption: 'Consumo',
  period: 'Período consumo',
  document_number: 'Nº de factura',
  second_expiration_on: 'Fecha 2do Vto.',
  second_expiration_amount: 'Importe 2do Vto.',
  defaultErrorMessage: 'Hubo un error al recuperar tus facturas. Intentá más tarde.',
  couponErrorMessage: 'Hubo un error al recuperar el cupón de pago, por favor intentá nuevamente más tarde',
  accountWithoutDebt: 'El suministro no registra liquidaciones emitidas pendientes de pago',
  loadingBill: 'Estamos recuperando tu factura...',
  detail: 'Detalle de factura'
});

i18next.addResources('es', 'EdelapBills', {
  pay: 'Pagar ahora',
  list: 'Descargar facturas',
  period: 'Período',
  expiration: 'Vencimiento',
  amount: 'Importe',
  bill: 'Factura',
  documentType: 'Tipo de recibo',
  docTypeInvoice: 'Factura',
  balance: 'Saldo',
  nis: 'NIS',
  confirmDownload: 'Confirmar descarga',
  confirmDownloadMssg: 'Esta seguro que desea confirmar la descarga?',
  download: 'Descargar',
  multipleDownload: 'Descargar todas',
  multipleBillsTitle: 'Descargá tus facturas',
  multipleBillsLoading: 'Estamos recuperando tus facturas..',
  payTitle: 'Pagar'
});

i18next.addResources('es', 'EdelapClaims', {
  number: 'Número',
  initDate: 'Fecha de inicio',
  formNumber: 'Nro. de reclamo',
  type: 'Tipo',
  actions: 'Acciones',
  locationOutOfBoundaries: 'La dirección se encuentra fuera del area de concesión.',
  askCancelAction: '¿Está seguro de cancelar el reclamo?',
  askReiterationAction: 'Esta seguro de reiterar el reclamo?'
});

i18next.addResources('es', 'EdelapClientSummary', {
  clientSummary: 'Resumen de usuario',
  selectText: 'Seleccionar',
  paymText: 'Pagar ahora',
  payAnotherAcc: 'Pagar otros suministros',
  totalAmountText: 'Saldo total',
  secondaryTopbarText: 'Estado de cuenta',
  nis: 'NIS',
  rate: 'Tarifa',
  status: 'Estado',
  balance: 'Saldo pendiente',
  arrow: 'Cuenta asignada'
});

i18next.addResources('es', 'EdelapComplaints', {
  complaints: 'Denuncias de conexiones clandestinas',
  crimeComplaint: 'Denuncia de Ilícito',
  crimeComplaintSubtitle:
    'Completá el siguiente formulario para enviar un informe. Cualquier información proporcionada será mantenida confidencial',
  crimeComplaintAlert:
    'Si sospechás que se está cometiendo un delito distinto del robo de energía, consulte a la policia local',
  complaintSubtitle: 'Robar energía es un delito',
  contactTitle: 'Hacé tu parte para detener el robo de energía',
  contactSubtitle:
    'Necesitamos tu ayuda para frenar el robo de energía. Si sospechás o sabés de un robo de energía, informalo',
  contactItem1: 'Enviá un formulario online',
  contactItem2: 'Llamá al {{complaintsPhone}} y denuncialo de forma anónima',
  contactItem3: 'Escribinos a {{complaintsMail}} y envianos una foto de lo que querés denunciar',
  initDate: 'Fecha de inicio'
});

i18next.addResources('es', 'EdelapTips', {
  title: 'Título',
  icon: 'icono'
});

i18next.addResources('es', 'EdelapAssessor', {
  title: 'Bienvenido al Asesor Energético',
  subtitle: 'Conocé tips para ser más eficiente en tu consumo de energía',
  energyAdvisor: 'Asesor Energético'
});

i18next.addResources('es', 'EdelapPayments', {
  amount: 'Importe a pagar',
  totalAmount: 'Total deuda seleccionada',
  totalConditionalAmount: 'Total deuda',
  checkingAccount: 'Estamos verificando su deuda...',
  paymentDocument: 'Cupón de pago',
  payOnline: 'Pagar online',
  nis: 'NIS',
  send: 'Enviar',
  selectCard: 'Seleccione la tarjeta con la que desea pagar',
  modalTitle: 'Pagar deuda',
  requireDataInput: 'Ingrese los datos de pago',
  cardNumber: 'N° de tarjeta',
  securityCode: 'Código de seguridad',
  expirationMonth: 'Mes de vencimiento',
  expirationYear: 'Año de vencimiento',
  name: 'Nombre del titular',
  email: 'Correo electronico',
  documentNumber: 'Numero de documento',
  documentType: 'Tipo de documento',
  cardRequired: 'Debe ingresar un número de tarjeta',
  codeRequired: 'Debe ingresar el código de seguridad',
  monthRequired: 'Debe ingresar el mes de vencimiento',
  yearRequired: 'Debe ingresar el año de vencimiento',
  nameRequired: 'Debe ingresar el nombre',
  emailRequired: 'Debe ingresar un correo electronico',
  docNumberRequired: 'El número de documento es requerido',
  sixteenDigitsValidation: 'El numero debe ser de 16 caracteres',
  threeDigitsValidation: 'El código debe tener 3 caracteres',
  monthValidation: 'Ingrese un mes valido.',
  yearValidation: 'Ingrese un año valido.',
  emailValidation: 'Formato de correo electronico invalido',
  paymentSuccessful: 'Su pago se registro correctamente.',
  paymentFailure: 'Hubo un problema al procesar su pago.',
  paymentDocDownloadInProgress: 'Estamos descargando tu cupón de pago',
  accountWithoutDebt: 'El suministro no registra liquidaciones emitidas pendientes de pago',
  downloadPaymentDocument: 'Descargar cupón',
  download: 'Descargar',
  downloadAll: 'Descargar todos',
  paymentDocumentLoading: 'Estamos recuperando tu cupón de pago...',
  multiplePaymentDocumentsLoading: 'Estamos recuperando tus cupones de pago...',
  payZeroError: 'El importe a procesar debe ser mayor a cero',
  maxAmountThreshold: `Atención: El importe a pagar excede el máximo permitido de {{amount}}`,
  maxDocsThreshold: `Atención: La cantidad de documentos a pagar excede el máximo permitido de {{docs}}`,
  paymentMethod: 'Método de pago',
  paymentDocumentFile: 'Cupon_pago_{{date}}.pdf',
  paymentDocumentPDF: `Cupon_De_Pago{{date}}.pdf`,
  multiplePaymentDocumentsZip: `Cupones_De_Pago{{date}}.zip`
});

i18next.addResources('es', 'EdelapPoints', {
  pointsSummary: 'Tu resúmen de puntos',
  exchange: 'Canjear',
  accumulated: 'Total de tus puntos acumulados',
  iconAltText: 'Puntos!',
  periodPoints: 'Tus puntos ganados en el último período',
  trophyAltText: 'Trofeo',
  pointsTransactionHistory: 'Historial de transacciones',
  period: 'Período',
  category: 'Categoría',
  points: 'Puntos',
  balance: 'Balance',
  automatic_debit: 'Débito Automático',
  digital_bill: 'Factura digital',
  voucher_exchange: 'Canje de puntos',
  pointsHistory: 'VER HISTORIAL COMPLETO',
  pointsHistoryMobile: 'Ver historial de transacciones',
  lastTransactions: 'Últimas transacciones',
  rewardsProgramTitle: 'Programa de Recompensas Utility CO!',
  rewardsProgram: 'Acumulá puntos por tus interacciones digitales y accede a beneficios',
  noMainCustomer: 'Aún no tenés suministros asociados que sumen puntos',
  noTransactions: 'Todavía no tenés transacciones'
});

i18next.addResources('es', 'EdelapProcedures', {
  number: 'Número',
  initDate: 'Fecha de inicio',
  formNumber: 'Nro. de trámite',
  formType: 'Tipo de '
});

i18next.addResources('es', 'EdelapSocialRate', {
  socialRateQuery: 'Consulta de tarifa social',
  requirementsTitle: 'Criterios para la determinación de la tarifa social',
  requirementsSubtitle:
    'El Ministerio de Energía y Minería de la Nación ha determinado los siguientes criterios de elegibilidad, los cuales serán aplicados por el Consejo Nacional de Coordinación de Políticas Sociales de la Presidencia de la Nación definiendo los beneficiarios, a través de la red SINTyS (Sistema de Identificación Nacional Tributario y Social):',
  queryButton: 'Consultar por DNI o CUIT',
  excludeTitle: 'Criterios de exclusión del beneficio',
  formTitle: 'Ingresá el NIS sobre el que deseás realizar la consulta',
  formSelectorTitle: 'Seleccioná el NIS sobre el que deseas realizar la consulta',
  formPlaceholder: 'Número de Servicio',
  formSelectorPlaceholder: 'Domicilio a consultar',
  query: 'Consultar',
  queryInProgress: 'Consultando',
  accountNotExists: 'El suministro ingresado es incorrecto',
  tooltip: ''
});

i18next.addResources('es', 'EdelapVouchers', {
  vouchersExchange: 'Canjear Puntos',
  exchange: 'Canjear',
  arrowLeft: 'Volver',
  points: 'PUNTOS',
  icon: 'icon',
  exchangeConfirmation: '¿Está seguro que desea canjear este voucher por {{points}} puntos?',
  confirm: 'Confirmar',
  exchangeVoucher: 'Canjear voucher',
  deletedVoucher: 'Este voucher ha sido eliminado.',
  expiredVoucher: 'Este voucher ha expirado.',
  alreadyUsedVoucher: 'Este voucher ya ha sido utilizado.',
  insufficientPoints: 'No tenés puntos suficientes.',
  exchanging: 'Canjeando',
  exchangeSucessful: 'El canje se realizó correctamente'
});

i18next.addResources('es', 'EdelapPublicBalanceQuery', {
  balanceQueryTitle: 'Saldo deudor',
  balanceQueryDescription:
    'En este sitio usted podrá consultar el saldo deudor del suministro informado hasta el día de la fecha. Incluye facturas no vencidas.',
  query: 'Consultar',
  resultModalTitle: 'Consulta de saldo'
});

i18next.addResources('es', 'EdelapPublicLastBill', {
  lastBillTitle: 'Importe y vencimiento de su ultima factura',
  lastBillDescription:
    'En este espacio usted podrá consultar el importe y vencimiento de su última factura emitida al día de la fecha',
  query: 'Consultar',
  resultModalTitle: 'Consulta de ultima factura'
});

i18next.addResources('es', 'EdelapPublicPayment', {
  getCoupon: 'Obtener cupón de pago',
  accountNumber: 'Número de suministro',
  accountNumberPlaceholder: 'Ingrese los {{accountLength}} dígitos del NIS',
  accountNumberLabel: 'Ingresá tu NIS',
  authorizedPlaces: 'Lugares de pago habilitados',
  neighbourPlaces: 'Acercate a una sucursal con sede en tu barrio',
  payOnline: 'Pagá online desde la comodidad de tu casa',
  accountNumberRequired: 'El número de suministro es obligatorio',
  publicPaymentTitle: 'Pago de facturas',
  publicPaymentDocumentTitle: 'Cupón de pago',
  publicPaymentByNisTitle: 'Pagá tus facturas',
  publicPaymentByNisSubtitle:
    'Ingresá tu NIS para recuperar tu deuda y poder pagar online con tarjeta de débito o crédito',
  searchPayments: 'Continuar',
  publicPaymentSubtitle:
    'Aquí podés pagar todas tus facturas vigentes o vencidas, abonar las facturas con aviso de suspensión y pagar la deuda del servicio suspendido con tarjeta de débito Visa o de crédito Visa, MasterCard o Nativa. Además podés consultar toda tu deuda, con aviso de suspensión o con servicio suspendido y abonaría través de los distintos canales.',
  publicPaymentDocumentSubtitle:
    'En este espacio usted podrá obtener el cupón de pago de sus últimas seis facturas impagas con los respectivos códigos de barra para abonar en cualquier medio de pago habilitado.',
  onlinePlacesTitle:
    'Con tarjeta de crédito o débito utilizando el código de pago electrónico que figura en el cupón.',
  placesTitle: 'Consultá los lugares de pago más cercanos a tu domicilio.',
  tooltip: ''
});

i18next.addResources('es', 'EdelapSignin', {
  welcomeTo: 'Bienvenido a',
  password: 'Contraseña',
  forgotPassword: 'Olvidé mi contraseña',
  signIn: 'Iniciar Sesión',
  login: '¡Hola! Ingresá tu usuario y contraseña',
  loginMobile: '¡Hola! Ingresá tu usuario y contraseña',
  noAccount: 'No tengo cuenta',
  register: 'Registrarme',
  // TODO: check why these messages are declared here and not in a generic handler
  joinToVirtualOffice: 'Ingresá a la oficina virtual',
  loading: 'Cargando...',
  continueWithoutRegistering: 'Continuar sin registrarte',

  // Password Recovery
  recoverPassword: 'Recuperar contraseña',
  recoveryStepsEmail:
    'Ingresá el email que utilizaste para registrarte y te enviaremos las instrucciones para recuperar tu contraseña',
  recoveryStepsDocType:
    'Ingresá el tipo y número de documento que utilizaste para registrarte y te enviaremos un email con las instrucciones para recuperar tu contraseña',
  sendRequest: 'Enviar solicitud',
  invalidUser: 'Usuario inválido',

  // Change Password
  changePassword: 'Cambiá tu contraseña',
  changePasswordAction: 'Cambiar mi contraseña',
  newPassword: 'Nueva contraseña',
  newPasswordConfirmation: 'Confirmá tu nueva contraseña',

  // Document types
  dni: 'DNI',
  cuit: 'CUIT',
  cip: 'CI provincial',
  cdi: 'Cédula de identidad',
  lc: 'Libreta cívica',
  le: 'Libreta de enrolamiento',
  cdt: 'Certificado de documento en trámite',
  other: 'Otros',
  passport: 'Pasaporte',
  numberInput: 'Ingrese su nro de documento',

  // Validations
  documentTypePlaceholder: 'Seleccioná el tipo de documento',
  documentTypeRequired: 'El tipo de documento es obligatorio',
  emailRequired: 'El email es obligatorio',
  emailFormat: 'El email no tiene un formato válido',
  docNumberRequired: 'El número de documento es obligatorio',
  dniFormat: 'El DNI ingresado no tiene un formato válido',
  cuitFormat: 'El CUIT ingresado no tiene un formato válido',
  otherFormat: 'El número de documento ingresado no tiene un formato válido',
  cipFormat: 'El CI Provincial ingresado no tiene un formato válido',
  cdiFormat: 'La Cédula de identidad ingresada no tiene un formato válido',
  leFormat: 'La Libreta de enrolamiento ingresada no tiene un formato válido',
  passportFormat: 'El Pasaporte ingresado no tiene un formato válido',
  lcFormat: 'La Libreta cívica ingresada no tiene un formato válido'
});

i18next.addResources('es', 'EdelapSignUpProgress', {
  action1: 'Ingresá',
  item1: 'tus datos',
  action2: 'Responde',
  item2: 'las preguntas',
  action3: 'Registra',
  item3: 'tu usuario',
  action4: 'Valida',
  item4: 'tu e-mail',
  action5: 'Ingresa',
  item5: 'tu suministro',
  action6: 'Valida',
  item6: 'tu relación',
  action7: 'Selecciona',
  item7: 'tus suministros',
  action8: 'Termina',
  item8: 'el registro'
});

i18next.addResources('es', 'EdelapSignup', {
  documentNumberPlaceholder: 'Número de documento',
  documentTypePlaceholder: 'Seleccione el tipo de documento',
  password: 'Contraseña',
  termsAndConditions: 'Al registrarse se aceptan los términos y condiciones',
  signUp: 'Registrarme',
  returnToSignIn: 'Volver al inicio de sesión',
  emailInUse: 'El email ya está siendo utilizado por otro usuario',
  nameMaxLength: 'El nombre tiene que tener menos de 20 caracteres',
  lastNameMaxLength: 'El apellido tiene que tener menos de 20 caracteres',
  passwordRequired: 'La contraseña es obligatoria',
  passwordMinLength: 'La contraseña debe tener mínimo {{minLength}} caracteres',
  passwordMaxLength: 'El largo máximo de la contraseña es de {{maxLength}} caracteres',
  passwordExactLength: 'La contraseña debe tener {{exactLength}} caracteres',
  emailRequired: 'El email es obligatorio',
  emailFormat: 'El email no tiene un formato válido',
  documentType: 'Tipo de documento',
  documentNumber: 'Número de documento',
  gender: 'Género',
  genderPlaceholder: 'Seleccione su género',
  name: 'Nombre',
  lastName: 'Apellido',
  bornDate: 'Fecha de nacimiento',
  bornDatePlaceholder: 'DD/MM/AAAA',
  activitiesInitialDateTitle: 'Fecha de inicio de actividades',
  activitiesInitialDate: 'Fecha de inicio de actividades según la constancia de CUIT',
  carrier: 'Compañía de celular',
  carrierPlaceholder: 'Seleccione la compañia de celular',
  cellNumber: 'Celular',
  cellNumberPlaceholder: 'Nro. de celular (sin 15)',
  phone: 'Teléfono',
  phonePlaceholder: 'Teléfono fijo',
  next: 'Siguiente',
  clientNumber: 'Número de suministro',
  registerAccount: 'Registrá tu suministro para comenzar',
  submit: 'Añadir suministro',
  wrongAnswers: 'Las respuestas son incorrectas',
  accountNumber: 'NIS',
  maxDateError: 'Para registrarte debés tener más de 18 años',
  minDateError: 'Fecha de nacimiento inválida',
  male: 'Masculino',
  female: 'Femenino',
  contactName: 'Nombre de contacto',
  contactNamePlaceholder: 'Ingrese el nombre de contacto',
  contactLastName: 'Apellido de contacto',
  contactLastNamePlaceholder: 'Ingrese el apellido de contacto',
  onePhoneNeeded: 'Debe ingresar al menos un teléfono de contacto',
  carrierNeeded: 'Debe ingresar la compañia de teléfono',
  acceptTermsConditions: 'Acepto los términos y condiciones',
  accept: 'Acepto',
  completeYourInformation: 'Completá tus datos',
  registerYourEmail: 'Registrá tu email',
  validateEmail: 'Validá tu email',
  addAccount: 'Añadí tu suministro',
  answerQuestions: 'Respondé las preguntas',
  answerValidationQuestions: 'Responde las preguntas de validación',
  serviceAdherence: 'Adherite a factura digital',
  addYourAccounts: 'Asociá tus suministros',
  acceptTerms: 'Aceptá los términos y condiciones',
  codeSent: 'Te enviamos un mail a {{userEmail}} con el código verificador. Ingresalo acá.',
  verificationCode: 'Código verificador',
  missingMail: '¿No llegó el email?',
  resend: 'Reenviar',
  validateEmail2: 'Validar email',
  invalidCode: 'Código de verificación incorrecto.',
  alreadyConfirmed: 'Email confirmado. Iniciá sesión',
  notCreated: 'El usuario no pudo ser creado.',
  notConfirmed:
    'Para finalizar el proceso de registración validá tu dirección de email ingresando el codigo que recibiste.',
  invalidEmail: 'Email inválido',
  platformDiscovery0: 'Como se enteró de la oficina virtual?',
  platformDiscovery1: 'Por campaña telefónica',
  platformDiscovery2: 'Por mail',
  platformDiscovery3: 'Por web',
  platformDiscovery4: 'Por referido',
  platformDiscovery5: 'Otros'
});

i18next.addResources('es', 'EdelapApiErrors', {
  expired: 'La sesión expiró',
  noConnection: 'El servicio no está disponible en este momento. Revisá tu conexión a internet'
});

i18next.addResources('es', 'EdelapValidations', {
  required: 'Campo obligatorio',
  invalidFormat: 'Formato inválido',
  invalidEmail: 'El email ingresado no es válido',
  invalidCard: 'La tarjeta ingresada no es válida',
  invalidCardExpDate: 'La fecha de vencimiento de la tarjeta es inválida',
  dateIsAfterActualDate: 'La fecha no puede ser posterior a la actual',
  maxFourDigits: 'Debe ingresar solamente 4 dígitos',
  minThreeDigits: 'Debe ingresar 3 dígitos.',
  minSixDigits: 'Debe ingresar 6 dígitos.',
  maxDate: 'La fecha debe ser menor o igual a {{date}}.',
  minDate: 'La fecha debe ser mayor a {{date}}',
  logicValidationMessage: 'El campo no cumple con la validación.',
  passwordRequireLetterAndNumber: 'La contraseña debe contener números y letras',
  cardNumberRequired: 'El número de tarjeta es requerido',
  invalidCardNumber: 'El número de tarjeta es inválido',
  holderNameRequired: 'El nombre del titular es requerido',
  expiresRequired: 'La fecha de vencimiento es requerida',
  invalidExpires: 'La fecha de vencimiento es inválida',
  securityCodeRequired: 'El código de seguridad es requerido',
  passwordSameValue: 'Las contraseñas ingresadas deben coincidir.'
});

i18next.addResources('es', 'EdelapTranslation', {
  iconAlt: 'Icono',
  avatar: 'Avatar',
  check: 'Seleccionado',
  fieldRequired: 'Este campo es requerido',
  yes: 'Si',
  no: 'No',
  enter: 'Ingresar a la oficina virtual'
});

i18next.addResources('es', 'EdelapTime', {
  secSingular: 'seg.',
  secPlural: 'seg.',
  minSingular: 'min.',
  minPlural: 'min.',
  hourSingular: 'hora',
  hourPlural: 'horas',
  daySingular: 'día',
  dayPlural: 'días',
  weekSingular: 'semana',
  weekPlural: 'semanas',
  monthSingular: 'mes',
  monthPlural: 'meses',
  yearSingular: 'año',
  yearPlural: 'años'
});

i18next.addResources('es', 'EdelapAccountHolderChange', {
  supply: 'NIS',
  supplyAddress: 'Dirección del suministro registrado',
  procedureNumber: 'Trámite N° {{procedure}}',
  accountHolderChangeTitle: 'Cambio de titularidad',
  accountHolderChangeSubtitle:
    'Aquí podrás realizar el cambio de la titularidad de un servicio eléctrico existente, por favor completá la información necesaria',
  continue: 'Continuar',
  checkLabel:
    'Declaro haber leído y conocer el Reglamento de Suministro Vigente (para consultar el Reglamento de Suministro Vigente [ingrese aquí]({{regulationURL}}))',
  userDataLabel:
    'Los datos ingresados en la presente tendrán carácter de Declaración Jurada y en cumplimiento a lo indicado en el artículo 6 de la Ley 25.326. La solicitud de la documentación anteriormente declarada queda supeditada al requerimiento futuro de parte de la Distribuidora, en caso de considerarlo oportuno.',
  userDebtCancel:
    'Es necesario que canceles la deuda existente asociada a este suministro para finalizar el trámite.',
  clientDebt: 'Cargos a abonar del suministro {{supply}}',
  ownDebt: 'Cargos a abonar del usuario {{holder}}',
  createProcedure: 'Ingresar solicitud',
  debtDescriptionNisBelongingUser: 'La deuda a abonar incluye la totalidad de las facturas impagas.',
  accountDebtDescription:
    'La deuda a abonar incluye la totalidad de las facturas impagas, el cálculo de consumo a la fecha y todo otro concepto que se encuentre pendiente (intereses por mora, gastos administrativos, devolución de depósito en garantía u otros conceptos)',
  cancel: 'Cancelar',
  payDebt: 'Pagar deuda',
  procedureHistory: 'Historial del trámite',
  userDebt: 'Deuda total: {{debt}}',
  supplyError:
    'El Suministro ingresado no puede ser trasladado a tu titularidad a través de la Oficina Virtual. Por favor comunicate con el Centro de Atención Comercial llamando al 0810 222 3335 de lunes a viernes de 8 a 18 horas y los sábados de 9 a 13 horas',
  nextBillCharge: 'Cargos a incluir en su próxima factura',
  wrongAccount: 'Nro de Suministro Inexistente',
  warrantyCharge: 'Depósito en garantía: {{amount}}',
  holderChangePending:
    'La presente solicitud sobre el suministro seleccionado se encuentra en curso. En la siguiente pantalla podés visualizar su estado y realizar las acciones que se encuentran disponibles sobre la misma',
  commercialHolderChangeError:
    'Por el momento, un Suministro con destino Comercial no puede ser trasladado a tu titularidad a través de la Oficina Virtual. Por favor comunicate con el Centro de Atención Comercial llamando al 0810 222 3335 de lunes a viernes de 8 a 18 horas y los sábados de 9 a 13 horas.',
  othersHolderChangeError:
    'Por el momento, un Suministro con destino Consorcio, obra y otros no puede ser trasladado a tu titularidad a través de la Oficina Virtual. Por favor comunicate con el Centro de Atención Comercial llamando al 0810 222 3335 de lunes a viernes de 8 a 18 horas y los sábados de 9 a 13 horas.',
  clientNumberInput: 'Ingresá los {{accountLength}} dígitos del NIS'
});

i18next.addResources('es', 'EdelapRegisterAccount', {
  supply: 'NIS',
  procedureNumber: 'Trámite N° {{procedure}}',
  supplyAddress: 'Dirección del suministro registrado',
  accountHolderChangeTitle: 'Alta de suministro',
  accountHolderChangeSubtitle:
    'Aquí podrás tramitar la reconexión del servicio para un suministro Residenciales dado de baja.',
  continue: 'Continuar',
  finishedProcedure:
    'El trámite finalizo correctamente. Debe identificar el habitáculo del medidor, pegando en el mismo un cartel con el número de suministro.',
  successModalTitle: 'Trámite finalizado correctamente',
  finishedProcedureWithNIS:
    'El trámite finalizó correctamente. Debe identificar el habitáculo del medidor con el número de NIS {{clientNumber}}',
  checkLabel:
    'Declaro haber leído y conocer el Reglamento de Suministro Vigente (para consultar el Reglamento de Suministro Vigente [ingrese aquí]({{regulationURL}}))',
  userDataLabel:
    'Los datos ingresados en la presente tendrán carácter de Declaración Jurada y en cumplimiento a lo indicado en el artículo 6 de la Ley 25.326. La solicitud de la documentación anteriormente declarada queda supeditada al requerimiento futuro de parte de la Distribuidora, en caso de considerarlo oportuno.',
  userDebtCancel:
    'Es necesario que canceles la deuda existente asociada a este suministro para finalizar el trámite.',
  clientDebt: 'Cargos a abonar del suministro {{supply}}',
  ownDebt: 'Cargos a abonar del usuario {{holder}}',
  createProcedure: 'Ingresar solicitud',
  accountDebtDescription:
    'La deuda a abonar incluye la totalidad de las facturas impagas y todo otro concepto que se encuentre pendiente (intereses por mora, gastos administrativos u otros conceptos)',
  cancel: 'Cancelar',
  payDebt: 'Pagar deuda',
  procedureHistory: 'Historial del trámite',
  userDebt: 'Deuda total: {{debt}}',
  supplyError:
    'El Suministro ingresado no puede ser dado de a través de la Oficina Virtual. Por favor comunicate con el Centro de Atención Comercial llamando al 0810 222 3335 de lunes a viernes de 8 a 18 horas y los sábados de 9 a 13 horas',
  cancelSuccess: 'Se ha cancelado el trámite correctamente',
  nextBillCharge: 'Cargos a incluir en su próxima factura',
  nextBillChargeContent:
    'Tasa de conexión: Dentro de las condiciones generales de habilitación del servicio, el usuario debe abonar el Cargo de Conexión de acuerdo al Cuadro Tarifario Vigente',
  wrongAccount: 'Nro de Suministro Inexistente',
  warrantyCharge: 'Depósito en garantía: {{amount}}',
  holderChangePending:
    'La presente solicitud sobre el suministro seleccionado se encuentra en curso. En la siguiente pantalla podés visualizar su estado y realizar las acciones que se encuentran disponibles sobre la misma',
  commercialHolderChangeError:
    'Por el momento, un Suministro con destino Comercial no puede ser dado de alta a través de la Oficina Virtual. Por favor comunicate con el Centro de Atención Comercial llamando al 0810 222 3335 de lunes a viernes de 8 a 18 horas y los sábados de 9 a 13 horas.',
  othersHolderChangeError:
    'Por el momento, un Suministro con destino Consorcio, obra y otros no puede ser dado de alta a través de la Oficina Virtual. Por favor comunicate con el Centro de Atención Comercial llamando al 0810 222 3335 de lunes a viernes de 8 a 18 horas y los sábados de 9 a 13 horas.',
  clientNumberInput: 'Ingresá los {{accountLength}} dígitos del NIS',
  select: 'Seleccioná uno de tus suministros asociados',
  enterNIS: 'Ingresá el número de suministro (NIS) ingresando los 9 dígitos.'
});

i18next.addResources('es', 'EdelapTerminationRequest', {
  supplySelection: 'Selección de suministro',
  cancel: 'Cancelar',
  submit: 'Solicitar baja',
  evaluateTerminationRequest:
    'La presente solicitud sobre el suministro seleccionado se encuentra en curso. En la siguiente pantalla podés visualizar su estado y realizar las acciones que se encuentran disponibles sobre la misma',

  terminationRequest: 'Baja de suministro',
  procedurePlaceholder:
    'Aquí solicitarás la baja del servicio eléctrico y el retiro del medidor.  Si en realidad deseás transferir el servicio a nombre de un tercero, el futuro titular podrá solicitar por este medio un cambio de titularidad',
  debtPlaceholder:
    'Recordá que deberás contar con tarjetas de Débito o Crédito para poder completar el trámite',
  debtCancelPlaceholder:
    'Es necesario que canceles la deuda existente asociada a este suministro para finalizar el trámite',
  terminationPending:
    'La presente solicitud sobre el suministro seleccionado se encuentra en curso. En la siguiente pantalla podés visualizar su estado y realizar las acciones que se encuentran disponibles sobre la misma',
  accountIsEmpty: 'Actualmente este trámite no está disponible para ninguna de tus cuentas.'
});

i18next.addResources('es', 'EdelapChangeDueDate', {
  title: 'Cambio de fecha de vencimiento para Jubilados/Pensionados',
  startDay: 'Día desde',
  endDay: 'Día hasta',
  sliderHelp: 'Mové los círculos para elegir el intervalo de fechas'
});

i18next.addResources('es', 'EdelapCreditCard', {
  yourName: 'Nombre del titular',
  cardNumber: 'Número de tarjeta',
  holderName: 'Nombre del titular de la tarjeta',
  expiry: 'Válido hasta',
  cvc: 'Cód. de seguridad',
  expDate: 'Vencimiento'
});

i18next.addResources('es', 'EdelapBanner', {
  register: 'Registrarme',
  banner1: 'Registrate',
  banner2: 'y accedé al detalle de tus facturas, realizá',
  banner3: 'tus consultas y reclamos en un click',
  banner4: '¡y mucho más!'
});

i18next.addResources('es', 'EdelapMaintenance', {
  maintenanceMessage: 'Estamos realizando tareas de mantenimiento, por favor ingresá nuevamente más tarde',
  networkError: 'Hubo un error de red. Por favor verificá tu conexión a Internet.'
});

i18next.addResources('es', 'EdelapEntitiesComplaint', {
  loginTitle: 'Ingrese su usuario para acceder al formulario de denuncias',
  username: 'Usuario',
  enter: 'Ingresar'
});
